export default {"src":"https://fishbrain.com/_next/static/media/connecticut.269043e0.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};